const vhFix = () => {
	if (!(!!window.MSInputMethodContext && !!document.documentMode)) {
		let vh = window.innerHeight;
		document.documentElement.style.setProperty('--vh', `${vh}px`);

		window.addEventListener('resize', () => {
			vh = window.innerHeight;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		});
	}
};

export {vhFix};
